import { trackCdp, trackEvent } from 'utilities/tracking';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.FreeWithRecaptcha.init());

Sq.Shop.FreeWithRecaptcha = {
  init() {
    if ($('#free-order-form').length === 0) {
      return;
    }

    if ($('.recaptcha_error').length > 0) {
      this.updateRecaptchaError();
    }

    this.getHtml();
    this.enableBindings();
  },

  getHtml() {
    this.$form = $('#free-order-form');
  },

  enableBindings() {
    this.$form.on('submit', () => {
      trackEvent({ name: 'reCAPTCHA', value: 'attempt' });
      trackCdp({
        name: 'reCAPTCHA',
        params: {
          feature: 'shop',
          status: 'attempt',
        },
      });
    });
  },

  updateRecaptchaError() {
    $('.recaptcha_error').addClass('error');
    trackEvent({ name: 'reCAPTCHA', value: 'failure' });
    trackCdp({
      name: 'reCAPTCHA',
      params: {
        feature: 'shop',
        status: 'failure',
      },
    });
  },
};
